<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80"
       style="fill:none;stroke:black;stroke-miterlimit:10">
    <path d="M23.48,58.64c.25-.98,5.96-3.29,8.11-4.16,1.45-.59,2.29-.93,2.64-1.15,1.55-.95,1.17-6.22.8-6.88l-.06-.08c-.97-1.18-1.67-2.89-1.92-4.68l-.07-.48-.48-.04c-.72-.05-1.63-1.34-1.63-2.72,0-.34.12-.53.28-.79.1-.16.22-.35.3-.58l.06-.17-.04-.17c-1.58-6.28-.65-10.99,2.55-12.93,2.51-1.52,6.59-2.15,9.58.05l.13.09.16.02c2.02.22,3.1,1.26,3.66,2.08,1.4,2.09,1.43,5.52.09,10.22l-.11.39.31.25c.34.27.84.82.84,1.16,0,1.44-.96,3.06-1.63,3.1l-.48.04-.07.48c-.22,1.57-.84,3.62-1.92,4.77l-.05.09c-.36.94-.66,5.86.83,6.78.35.22,1.19.56,2.64,1.15,2.15.87,7.86,3.19,8.11,4.16"/>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGebruikersgedrag extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #020203;
  stroke-miterlimit: 10;
}

.st1 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}

.st2 {
  fill: none;
  stroke: #000000;
  stroke-linecap: round;
  stroke-miterlimit: 10;
}
</style>
